// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2rQaj","title":"BackImages_title__2v66k","images":"BackImages_images__2V0Ty"};